import { CurrentUserIndexResponse } from "./currentUser";

const url = "/api/signup";

export interface RegistrationsCreateParams {
  acceptedTerms: boolean;
  email: string;
  password?: string;
  referralToken?: string | null;
}

export type RegistrationsCreateResponse = CurrentUserIndexResponse;

export const registrationsCreateQuery = (
  params: RegistrationsCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});

export interface RegistrationsOnboardingCreateParams {
  acceptedAdditionalTerms: boolean;
  acceptedTerms: boolean;
  email: string;
  firstName: string;
  lastName: string;
  referralToken?: string | null;
  partnerSlug: string;
}

export type RegistrationsOnboardingCreateResponse = CurrentUserIndexResponse;

export const registrationsOnboardingCreateQuery = (
  params: RegistrationsOnboardingCreateParams,
) => ({
  url: "/api/v1/registrations",
  method: "POST",
  body: params,
});
